module.exports = __webpack_public_path__ + "7a06ff95dac9b66b61fc5a9f9a55e42b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/iconfont/iconfont.ttf
// module id = 353
// module chunks = 0 204 209